import React, { Component } from "react";
import resume from "../assets/premakumar_nj2_074.pdf";

class About extends Component {
  render() {
    if (this.props.data) {
      var name = this.props.data.name;
      var profilepic = "images/" + this.props.data.image;
      var street = this.props.data.address.street;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var zip = this.props.data.address.zip;
      var phone = this.props.data.phone;
      var email = this.props.data.email;
    }

    return (
      <section id="about">
        <div style={{ display: "flex" }} className="row">
          {/* <div className="three columns">
            <img
              className="profile-pic"
              src={profilepic}
              alt="Alex Bangau Profile Pic"
            />
          </div> */}

          <div className="nine columns main-col">
            <h2>About Me</h2>

            <p>
              Enthusiastic to start a career in an existing tech company that
              allows growth and continued learning. Always eager to learn new
              skills and explore efficient ways of solving problems. <br />
              <br />I just graduated from the Full Stack Developer Bootcamp from
              Masai School and I am now looking for my first full time
              development role with room to grow and learn. I find the
              creativity and visual aspects of Frontend and Backend very
              interesting and would love the opportunity to grasp more about Web
              Development.
            </p>
            <div className="row">
              <div className="columns contact-details">
                <h2>Contact Details</h2>
                <p className="address">
                  <span>{name}</span>
                  <br />
                  <span>
                    {street}
                    <br />
                    {city} {state}, {zip}
                  </span>
                  <br />
                  <span>{phone}</span>
                  <br />
                  <span>
                    <a
                      href={`mailto:${email}?subject=The%20subject%20of%20the%20mail`}
                    >
                      {email}
                    </a>
                  </span>
                </p>
              </div>
              <div className="columns download">
                <p>
                  <a
                    href={resume}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button"
                  >
                    <i className="fa fa-download"></i>Download Resume
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div style={{ width: "50%" }}>
            <img
              className="profile-pic"
              width="100%"
              height="100%"
              // style={{ paddingLeft: "25px" }}
              src={profilepic}
            />
          </div>
        </div>
      </section>
    );
  }
}

export default About;
